import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(VSelect, {
        attrs: {
          items: _vm.dateOptions,
          "item-text": "text",
          "item-value": "value",
          dense: "",
        },
        on: { change: _vm.loadInfo },
        model: {
          value: _vm.selectedOption,
          callback: function ($$v) {
            _vm.selectedOption = $$v
          },
          expression: "selectedOption",
        },
      }),
      _c(
        VCard,
        [
          _vm.isLoading
            ? _c(VProgressLinear, {
                staticClass: "d-flex align-center justify-center",
                attrs: { indeterminate: "", color: "grey", size: "20" },
              })
            : _vm._e(),
          _c(
            VRow,
            { staticClass: "d-flex align-center", attrs: { "no-gutters": "" } },
            [
              _c(
                VCol,
                { staticClass: "mb-1 pa-2", attrs: { cols: "12" } },
                _vm._l(_vm.sections, function (section) {
                  return _c(
                    VRow,
                    { key: section.desc },
                    [
                      _c(
                        VCol,
                        [
                          _c(
                            VRow,
                            [
                              _c(
                                VCol,
                                { staticClass: "d-flex align-center" },
                                [
                                  _c(
                                    VIcon,
                                    {
                                      staticClass: "icon-style",
                                      style: { backgroundColor: section.color },
                                      attrs: { color: "white" },
                                    },
                                    [_vm._v(_vm._s(section.icon))]
                                  ),
                                  _c(
                                    "h6",
                                    {
                                      staticClass: "mt-1 ml-1 font-weight-bold",
                                    },
                                    [_vm._v(_vm._s(_vm.$t(section.desc)))]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._l(section.metrics, function (metric) {
                            return _c(
                              VRow,
                              { key: metric.desc },
                              [
                                _c(
                                  VCol,
                                  {
                                    staticClass: "text-small",
                                    attrs: { cols: "9" },
                                  },
                                  [_vm._v(_vm._s(_vm.$t(metric.desc)))]
                                ),
                                _c(
                                  VCol,
                                  {
                                    staticClass: "text-small",
                                    attrs: { cols: "3" },
                                  },
                                  [_vm._v(_vm._s(metric.value))]
                                ),
                              ],
                              1
                            )
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  )
                }),
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }